import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const MapControls = styled(Stack)(
  ({theme}) => css`
    background-color: ${theme.colors.backgroundPrimary};
    position: relative;
    border-radius: 5px 0 5px 5px;
    gap: 0;
  `
);
